import { OrgId } from "./Org.schema";
import { z } from "zod";
import { GoogleAddressZod } from "../constants";

export const OrgVenueZod = z.object({
  id: z.string(),
  orgId: z.string(),
  name: z.string(),
  location: GoogleAddressZod,
  createdAtMS: z.number(),
  updatedAtMS: z.number()
});

export type OrgVenue = z.infer<typeof OrgVenueZod>;
